document.addEventListener('DOMContentLoaded', function () {

  // Elements
  const drawer = document.getElementById('quoteDrawer');
  const overlay = document.getElementById('drawerOverlay');
  const closeBtn = document.getElementById('closeDrawer');
  const triggers = document.querySelectorAll('.quote-trigger');

  // Stop if drawer doesn't exist
  if (!drawer || !overlay || !closeBtn) {
    console.warn('Quote drawer elements not found.');
    return;
  }

  // Open drawer
  function openDrawer(e) {
    e.preventDefault();

    drawer.classList.add('open');
    overlay.classList.add('show');
    document.body.classList.add('drawer-open');
  }

  // Close drawer
  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('show');
    document.body.classList.remove('drawer-open');
  }

  // Open when clicking any quote button
  triggers.forEach(function(button) {
    button.addEventListener('click', openDrawer);
  });

  // Close button
  closeBtn.addEventListener('click', closeDrawer);

  // Click outside drawer
  overlay.addEventListener('click', closeDrawer);

  // ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeDrawer();
    }
  });

});